import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL;

export interface TicketData {
    service: string;
    description: string;
    additionalComment: string;
    equipments: number[];
}

export const createTicket = async (ticketData: TicketData, plantId: number): Promise<void> => {
    try {
        return axios.post(`${apiUrl}/tickets/plants/${plantId}`, ticketData, {withCredentials: true});
    } catch (error: any) {
        if (error.response) {
            throw new Error(error.response.data.message || 'Error al crear el ticket.');
        } else if (error.request) {
            throw new Error('No se puede conectar al servidor.');
        } else {
            throw new Error(error.message || 'Error inesperado.');
        }
    }
};
